import { useHasProperty } from "@/hooks";
import { RootState } from "@/services/redux/store";
import { IHasPages } from "@/utils/types/component";
import { useSelector } from "react-redux";

const HasSKUReportWrapper: React.FC<IHasPages> = ({ children }) => {
  const { hasSkuReport, hasBuilder } = useHasProperty();
  const devMode = useSelector(
    (state: RootState) => state.developerMode.isEnabled
  );

  if (hasSkuReport || devMode || hasBuilder) return <>{children}</>;

  return <></>;
};

export default HasSKUReportWrapper;
